import EXAMPLE from "../../assets/images/example.png";
import React, { Component } from "react";
import Swal from "sweetalert2";
import Switch from "react-switch";
import Navbar from "../../components/Navbar.js";
import { Modal, Toast } from "react-bootstrap";
import {
  profile,
  alert,
  format_date,
  GET,
  POST,
  PUT,
  DELETE,
  DatePicker,
  Status,
  loading,
} from "../../components/CustomComponent.js";
import Pagination from "@mui/material/Pagination";
import Resizer from "react-image-file-resizer";
import LOGO from "../../assets/images/logo.png";
import "../../assets/css/bootstrap.css";
import "../../assets/css/style.css";
export default class Banners extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,

      count: 0,

      data: [],

      news_id: "",
      description: "",
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    loading(true);
    let body = {
      page: page,
    };
    let result = await GET("api/admin/news/list", body);
    if (result?.status) {
      this.setState({ data: result.data, count: result.count });
    }
    loading(false);
  };
  CreateUpdate = async () => {
    if (!this.state.description) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกข้อมูลข่าวสาร");
      return;
    }
    loading(true);
    let id = this.state.news_id;
    let body = {
      description: this.state.description,
    };
    let result = !id
      ? await POST("api/admin/news/create", body)
      : await PUT("api/admin/news/update/" + id, body);
    if (result?.status === true) {
      alert("#", "success");
    }
    loading(false);
  };
  Delete = async (id) => {
    if (
      await alert(
        "",
        "info",
        "ยืนยัน",
        "ยืนยันการลบข้อมูลนี้หรือไม่?",
        "ลบข้อมูล",
        "ยกเลิก"
      )
    ) {
      loading(true);
      let result = await DELETE("api/admin/news/delete/" + id, null);
      if (result?.status) {
        alert("#", "success");
      }
      loading(false);
    }
  };
  render() {
    return (
      <div className="w-100 min-vh-100">
        <Navbar
          header="Transaction History"
          page1="หน้าหลัก"
          page2="ข่าวสาร"
        />
        <div className="body px-3 pb-3 pt-0">
          <h4 className="fw-bold mb-2">ข่าวสาร</h4>
          <div className="d-flex justify-content-end">
            <button
              className="btn btn-success px-4 mb-2"
              onClick={async () => {
                this.setState({
                  modal_create: true,
                  news_id: "",
                  description: "",
                });
              }}
            >
              เพิ่มข่าวสาร
            </button>
          </div>
          <div className="card rounded border-0 overflow-hidden">
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead className="bg-light text-secondary">
                  <tr>
                    <th className="wpx-50 text-center">ลำดับ</th>
                    <th>วันเวลา</th>
                    <th>ข่าวสาร</th>
                    <th className="text-center wpx-90">จัดการ</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.data?.map((item, index) => (
                    <tr key={"table_" + index}>
                      <td className="text-center">{index + 1}</td>
                      <td>
                        {item.createdAt ? format_date(item.createdAt,"dd/mm/yyyy hh:mm") : ""}
                      </td>
                      <td>{item.description || "-"}</td>
                      <td className="py-1">
                        <div className="d-flex justify-content-center">
                          {/* Update */}
                          <div
                            className="icon text-14 mx-1 d-flex align-items-center justify-content-center wpx-25 hpx-25 pointer rounded-3 bg-warning-light text-orange"
                            onClick={async () => {
                              this.setState({
                                modal_update: true,
                                news_id: item.news_id,
                                description: item.description
                              });
                            }}
                          >
                            {"\uf044"}
                          </div>
                          {/* Delete */}
                          <div
                            className="icon text-14 mx-1 d-flex align-items-center justify-content-center wpx-25 hpx-25 pointer rounded-3 bg-danger-light text-danger"
                            onClick={async () => {
                              this.Delete(item.news_id);
                            }}
                          >
                            {"\uf1f8"}
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-between p-3">
            <small>ทั้งหมด {this.state.count} รายการ</small>
            <Pagination
              count={Math.ceil(this.state.count / 10)}
              showFirstButton
              showLastButton
              onChange={(_, page) => {
                this.Get(page);
              }}
            />
          </div>
        </div>
        {/* CREATE UPDATE */}
        <Modal
          show={this.state.modal_create || this.state.modal_update}
          onHide={() =>
            this.setState({ modal_create: false, modal_update: false })
          }
          size="lg"
        >
          <Modal.Header closeButton>
            <h5 className="fw-bold mb-0">
              {this.state.modal_create
                ? "เพิ่ม"
                : this.state.modal_update
                ? "แก้ไข"
                : ""}
              ข่าวสาร
            </h5>
          </Modal.Header>
          <Modal.Body>
              <textarea
              rows={15}
                className="form-control"
                onChange={(e) => {
                  this.setState({ description: e.target.value });
                }}
                value={this.state.description}
              />
          </Modal.Body>
          <Modal.Footer className="py-1">
            <div className="w-100 d-flex">
              <button
                className="btn btn-danger w-100 me-1"
                onClick={() => {
                  this.setState({ modal_create: false, modal_update: false });
                }}
              >
                ยกเลิก
              </button>
              <button
                className="btn btn-success w-100 ms-1"
                onClick={() => {
                  this.CreateUpdate();
                }}
              >
                บันทึก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
